import * as Adaptive from "adaptivecards";
import { BooleanPropertyEditor, ChoicePropertyEditor, IVersionedChoice, StringPropertyEditor } from "adaptivecards-designer";

const displayLabelProperty = new Adaptive.StringProperty(Adaptive.Versions.v1_0, "displayLabel", true);
const dataSourceProperty = new Adaptive.StringProperty(Adaptive.Versions.v1_0, "dataSource", true, undefined, "0");
const displayChoicesProperty = new Adaptive.EnumProperty(Adaptive.Versions.v1_0, "displayChoices", []);
const requireFieldProperty = new Adaptive.BoolProperty(Adaptive.Versions.v1_0, "requireField", false);

export class PickerBase extends Adaptive.TextInput {
    static readonly displayLabelProperty = displayLabelProperty;
    static readonly dataSourceProperty = dataSourceProperty;
    static readonly displayChoicesProperty = displayChoicesProperty;
    static readonly requireFieldProperty = requireFieldProperty;

    @Adaptive.property(displayLabelProperty)
    get displayLabel(): string | undefined {
        return this.getValue(PickerBase.displayLabelProperty);
    }

    set displayLabel(value: string | undefined) {
        this.setValue(PickerBase.displayLabelProperty, value);
        this.updateLayout();
    }

    @Adaptive.property(dataSourceProperty)
    get dataSource(): string | undefined {
        return this.getValue(PickerBase.dataSourceProperty);
    }

    set dataSource(value: string | undefined) {
        this.setValue(PickerBase.dataSourceProperty, value);
        this.updateLayout();
    }

    @Adaptive.property(displayChoicesProperty)
    get displayChoices(): any[] | undefined {
        return this.getValue(PickerBase.displayChoicesProperty);
    }

    set displayChoices(value: any[] | undefined, ) {
        this.setValue(PickerBase.displayChoicesProperty, value);
        this.updateLayout();
    }

    @Adaptive.property(requireFieldProperty)
    get requireField(): boolean | undefined {
        return this.getValue(PickerBase.requireFieldProperty);
    }

    set requireField(value: boolean | undefined) {
        this.setValue(PickerBase.requireFieldProperty, value);
        this.updateLayout();
    }
    
    //#endregion

    protected internalRender(): HTMLElement | undefined {

        let choiceSetInput = new Adaptive.ChoiceSetInput();
        choiceSetInput.setParent(this);
        choiceSetInput.label = this.displayLabel;
        choiceSetInput.isRequired = this.requireField;

        choiceSetInput.choices = this.displayChoices ?? [];
        if(this.defaultValue)
            choiceSetInput.defaultValue = this.defaultValue;

        const renderedElement =  choiceSetInput.render();
        this.inputControlContainerElement.style.display = "block";

        return renderedElement;
    }

    updateLayout(processChildren: boolean = true) {
        super.updateLayout(processChildren);
    }
}

export const PropertyKeys = {
    "dataSource": "dataSource",
    "displayLabel": "displayLabel",
    "requireField": "requireField",
    "isMultiSelectField": "isMultiSelectField",
    "presentation": "presentation",
    "errorMessage": "errorMessage"
}

export const PresentationKeys = {
    "list": "list",
    "lookup": "lookup"
}

export const getPropertyEditorInstance = (elementKey: string, propertyKey: string, defaultValue?: any) => {
    switch(propertyKey){
        case PropertyKeys.dataSource: 
            return new ChoicePropertyEditor(Adaptive.Versions.v1_0, PropertyKeys.dataSource, "Data Source", defaultValue);
        case PropertyKeys.displayLabel:
            return new StringPropertyEditor(Adaptive.Versions.v1_0, PropertyKeys.displayLabel, "Label", false);
        case PropertyKeys.requireField:
            return new BooleanPropertyEditor(Adaptive.Versions.v1_0, PropertyKeys.requireField, "Required", false);
        case PropertyKeys.isMultiSelectField:
            return new BooleanPropertyEditor(Adaptive.Versions.v1_0, PropertyKeys.isMultiSelectField, "Allow multi selection", true);
        case PropertyKeys.presentation:
            const viewChoices: IVersionedChoice[] = [
                { name: "List", value: PresentationKeys.list, targetVersion: Adaptive.Versions.v1_0 }, 
                { name: "Lookup", value: PresentationKeys.lookup, targetVersion: Adaptive.Versions.v1_0 }
            ];
            return new ChoicePropertyEditor(Adaptive.Versions.v1_0, PropertyKeys.presentation, "Presentation", viewChoices , false);
        case PropertyKeys.errorMessage:
            return new StringPropertyEditor(Adaptive.Versions.v1_0, "errorMessage", "Error Message", false);
        case elementKey:
        default:
            return null;
    }
}